import { IScope } from "angular";
import { IWorkItemScope, WorkItemController } from "../workItemController";
import { FieldDefinitionOptions } from "../../../model/ProcessApi";
export interface OptionFieldOption {
  Value: string;
  Text: string;
}

export interface OptionFieldDefinitionOptions extends FieldDefinitionOptions {
  Options: OptionFieldOption[];
}

export class OptionController extends WorkItemController {
  static $inject = ["$scope"];

  selectedItem?: OptionFieldOption;

  constructor($scope: IWorkItemScope) {
    super($scope);

    this.selectedItem = this.getOptionByValue($scope.model!.value);
  }

  selectedItemChanged(value: string) {
    this.selectedItem = this.getOptionByValue(value);
    this.setValue(value);
  }

  private getOptionByValue(value: string) {
    return this.$scope.to.Options.find(
      (o: OptionFieldOption) => o.Value === value
    );
  }
}
